import {EnvironmentProviders, makeEnvironmentProviders} from '@angular/core';
import {FirebaseOptions, initializeApp, provideFirebaseApp} from '@angular/fire/app';
import {getAuth, provideAuth} from '@angular/fire/auth';

// We don't have a consolidated Environment type for Hawk/Phoenix yet.  When we do (and define it in Aviary), we can use that and remove this.
export interface MinimalEnvironment {
  readonly firebase: FirebaseOptions;
}

export function provideFirebase(environment: MinimalEnvironment): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAuth(() => getAuth())
  ]);
}
